import { Head } from '@playbooks/ui/components/head';

const AuthWrapper = ({ title = '', children }) => {
	// Render
	return (
		<div className='flex-column min-h-screen bg-canvas text-foreground'>
			<Head title={title} />
			<main className='hero-grid auth-grid relative z-0 flex flex-1 items-center justify-center px-4 py-8 sm:py-12'>
				<div className='relative z-1 w-full max-w-xs'>{children}</div>
			</main>
		</div>
	);
};

export { AuthWrapper };
